import { jsx } from 'react/jsx-runtime';

var r="tw-preflight";function n(t){let{children:e,height:s,width:i}=t;return jsx("div",{className:r,style:{height:s,width:i},children:e})}

export { r as a, n as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5PCVVNPO.js.map